export const appInfoBadgeDataHooks = {
  APP_INFO_BADGE: 'app-info-badge',
};
